import { render, staticRenderFns } from "./publish_me.vue?vue&type=template&id=c00a8286"
import script from "./publish_me.vue?vue&type=script&lang=js"
export * from "./publish_me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports